import React, { useEffect, useState } from "react";
import { UtilityFunctions } from "../utils/UtilityFunctions";
import { STRING_CONSTANTS } from "../utils/constants/stringConstants";
import ToastHeader from "../components/toastHeader";
import ValidationErrorToast from "../components/validationErrorToast";
import { api } from "../middleware/api";
import SuccessToast from "../components/successToast";
import { get } from 'lodash';
import { END_POINTS } from "../utils/constants/endPoints";
import { authCardStyles as styles } from './authCardStyles';

const ResetPassword = (props) => {
  const [password, setPassword] = useState("");
  const [pwdType, setPwdType] = useState("password");
  const [isTokenActive, setIsTokenActive] = useState(true);
  const parameters = { uidb: props.match.params.uidb, token: props.match.params.token }
  const [btnClick, setBtnClick] = useState(false);
  const hasNumber = /\d/;

  const testPwd = UtilityFunctions.validatePassword(password);

  useEffect(() => {
    api.get(`${parameters.uidb}/${parameters.token}/check-token/`, null)
      .then(
    )
      .catch(e => {
        setIsTokenActive(false)
      })
  }, [])

  const togglePassword = () => {
    if (pwdType === "password") {
      setPwdType("text");
      return;
    }
    setPwdType("password");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setBtnClick(true);
    if (UtilityFunctions.isEmptyOrNullOrUndefined(password)) {
      ValidationErrorToast(STRING_CONSTANTS.formLabelString.label_password, STRING_CONSTANTS.validationString.req_password);
    } else {
      if (!password) {
        return;
      }
      let data = {
        newPassword: password,
      };
      api.post(`${END_POINTS.resetPassword}${parameters.uidb}/${parameters.token}/`, data)
        .then((res) => {
          // redirect to successful page
          SuccessToast(STRING_CONSTANTS.formLabelString.label_password, get(res, 'data.password[0]'))
          props.history.push(STRING_CONSTANTS.navigationString.login)
        })
        .catch(function (error) {
          ToastHeader(error);
        });
    }
  };

  const hintStyle = (ok: boolean) =>
    password.length <= 0 ? styles.hintNeutral : ok ? styles.hintOk : styles.hintBad;

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.header}>
          <span style={styles.logoChip} onClick={() => props.history.push(STRING_CONSTANTS.navigationString.login)}>
            <img alt="MPLOI" style={styles.logo} src={UtilityFunctions.getImageURL() + "logo_White.svg"} />
          </span>
        </div>

        {!isTokenActive ?
          <>
            <h1 style={styles.title}>Link expired</h1>
            <p style={styles.subtitle}>This reset link has expired for security reasons. Please request a new one.</p>
            <button
              type='button'
              style={styles.button}
              onClick={() => props.history.push(STRING_CONSTANTS.navigationString.forgotpassword)}
            >
              Send a new link
            </button>
          </> :
          <>
            <h1 style={styles.title}>Reset password</h1>
            <p style={styles.subtitle}>Create your new password below.</p>

            <form onSubmit={handleSubmit} noValidate>
              <div style={styles.formGroup}>
                <label htmlFor="floatingInputpwd" style={styles.label}>New Password</label>
                <input
                  type={pwdType}
                  id="floatingInputpwd"
                  placeholder="Enter Password"
                  name='password'
                  style={{
                    ...styles.input,
                    ...(btnClick && testPwd === false ? styles.inputError : {})
                  }}
                  value={password}
                  onChange={(e) => { setPassword(e.target.value); setBtnClick(false); }}
                />
                <div onClick={togglePassword} style={styles.inputIcon}>
                  <img src={pwdType === "password" ? UtilityFunctions.getImageURL() + 'eyeOff.png' : UtilityFunctions.getImageURL() + 'eyeOn.png'} alt="" />
                </div>
              </div>

              <ul style={styles.hintList}>
                <li style={hintStyle(password.length >= 8)}>Min. 8 characters</li>
                <li style={hintStyle(hasNumber.test(password))}>At least 1 number</li>
              </ul>

              <button
                type='submit'
                style={{ ...styles.button, ...(testPwd === true ? {} : styles.buttonDisabled) }}
              >
                Save new password
              </button>
            </form>
          </>
        }
      </div>
    </div>
  );
};
export default ResetPassword;
